import type { TableView } from "owa-mail-list-store";
import { mutatorAction } from "satcheljs";

const setSelectionSLVMutator: (tableView: TableView, checkedState: boolean) => void = mutatorAction("setSelectionSLV", function setSelectionSLV(tableView: TableView, checkedState: boolean): void {
    tableView.isInSelectAllStateSLV = checkedState;
});
export default setSelectionSLVMutator;
